"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.truncate = void 0;
const tslib_1 = require("tslib");
const truncate_1 = tslib_1.__importDefault(require("lodash/truncate"));
/**
 * Truncate a string to `options.length` characters, separated by word boundaries
 *
 * @see https://lodash.com/docs/4.17.15#truncate
 */
function truncate(value, options) {
    return truncate_1.default(value, {
        // Add 6 to the length because '&hellip;' counts as 1 length, not 8.
        length: Math.max(0, ((options === null || options === void 0 ? void 0 : options.length) || 30) + 6),
        // Separate on word boundaries
        separator: /[.,!? ]/,
        // Use the ellipsis character instead of three dots
        omission: "&hellip;",
    });
}
exports.truncate = truncate;
//# sourceMappingURL=index.js.map